var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRufbus = function SvgRufbus(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m19.3 10.3.4.4a1 1 0 0 0 .71.3H23a1 1 0 0 0 1-1s0-4-8-4-8 4-8 4a1 1 0 0 0 1 1h2.59a1 1 0 0 0 .7-.3l.42-.4c.18-.2.29-.45.3-.72C13.03 8 13.4 8 16 8c2.6 0 2.96 0 3 1.58 0 .27.1.53.3.71Zm.01 4.7.51 3h-7.64l.5-3h6.63ZM12 19.05V19h8v3h-8v-2.95ZM10 19V19H8.75a.75.75 0 0 1-.75-.75v-.5c0-.41.34-.75.75-.75h1.57l.54-3.17a1 1 0 0 1 .98-.83h8.32a1 1 0 0 1 .98.83l.54 3.17h1.57c.41 0 .75.34.75.75v.5c0 .41-.34.75-.75.75H22v3.4l-.01.2.01.15v2.5c0 .41-.34.75-.75.75h-.5a.75.75 0 0 1-.75-.75V24h-8v1.25c0 .41-.34.75-.75.75h-.5a.75.75 0 0 1-.75-.75v-2.5l.01-.14-.01-.21v-3.39Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRufbus);
export default ForwardRef;